import React, {Component} from 'react';
import Tooltip from './index';

class Props {
    player;
}

class ConfirmedComponent extends Component<Props> {
    render() {
        const {player} = this.props;

        return (
            <Tooltip
                iconClassName={`fa ${player.confirmed ? 'fa-check' : 'fa-question-circle'}`}
                subject={`Position Confirmed: ${player.confirmed ? 'Yes' : 'Unknown'}`}
            />
        );
    }
}

export {ConfirmedComponent};
